import ApiSIT from '@/api/apiErp/apiErpSIT';

export default {
  setBreadcrumbs({ commit }, { breadcrumbs = [] }) {
    commit('setBreadcrumbs', breadcrumbs);
  },

  getProduct({ rootState }, { productId }) {
    try {
      return rootState.app.productCategories.find(x => x.id == productId);
    } catch (e) {
      throw e;
    }
  },

  async getSheet({ commit }, { sheetId }) {
    try {
      const response = await ApiSIT.getSheet(sheetId);
      return response.data;
    } catch (e) {
      throw e;
    }
  },
};
